import { types, isType } from "mobx-state-tree"

export const CustomWager = types.model({
    _id: types.identifier,
    bytes32Id: types.string,
    maker: types.string,
    makerETHAddress: types.string,
    taker: types.optional(types.string, ""),
    takerETHAddress: types.optional(types.string, ""),
    judge: types.optional(types.string, ""),
    value: types.number,
    odds: types.number,
    endTime: types.number,
    reportingEndTime: types.number,
    outcomeOne: types.string,
    outcomeTwo: types.string,
    makerChoice: types.number,
    takerChoice: types.number,
    makerWinVote: types.optional(types.number, 0),
    takerWinVote: types.optional(types.number, 0),
    judgeVote: types.optional(types.number, 0),
    settled: types.boolean,
    cancelled: types.boolean,  
    winner: types.optional(types.string, "")
});


// WEBPACK FOOTER //
// ./src/models/CustomWager.js